import React from 'react';
import './App.css';
import Form from './form/Form';

// zoho form
function App() {
    return (
        <div className="App">
            <Form />
        </div>
    );
}

export default App;
